import { useLocation } from 'react-router-dom';

/**
 * Internal tools are hidden unless the URL carries ?change=true.
 *
 * The default experience is the guided flow alone; the calculator, settings,
 * FAQ and sales material are for staff. This is a UI gate for keeping the
 * surface simple, not an access control — the parameter is visible to anyone
 * and trivially added, so nothing sensitive may sit behind it.
 */
export const UNLOCK_PARAM = 'change';

export const useUnlocked = () => {
    const { search } = useLocation();
    return new URLSearchParams(search).get(UNLOCK_PARAM) === 'true';
};

/**
 * Append the unlock parameter to an in-app path.
 * Without this, following any link would drop the parameter and re-lock the UI
 * mid-session.
 */
export const withUnlock = (path, unlocked) => {
    if (!unlocked) return path;
    const [base, hash] = path.split('#');
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}${UNLOCK_PARAM}=true${hash ? '#' + hash : ''}`;
};
